'use client';
import React from 'react';
import styles from './style.module.scss';

interface Props {
    openMenu: () => void;
}

const Burger: React.FC<Props> = ({ openMenu }) => {
    return (
        <div onClick={openMenu} className={styles.button}>
            <div className={styles.background}></div> 
            <div className={styles.hamburger}></div>
            <p>Menu</p>
        </div>
    );
};

export default Burger;
